var $cf49656c53ab0bec$exports = {};
$cf49656c53ab0bec$exports = {
    "loading": `\u{12E}keliama...`,
    "loadingMore": `\u{12E}keliama daugiau...`
};


export {$cf49656c53ab0bec$exports as default};
//# sourceMappingURL=lt-LT.mjs.map
